import React, { FC, useEffect } from 'react'
import i18n from 'i18next'
import { IMenuItemProps } from '../Bill'

const MenuItem: FC<IMenuItemProps> = ({ onSelect }) => {
  useEffect(() => {
    if (!window.wx) {
      const script = document.createElement('script')
      script.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js'
      document.body.appendChild(script)
    }
  }, [])

  return (
    <li className='group'>
      <div className='group-title' onClick={() => onSelect('wechatPay')}>
        <img src={require('@img/payment/wechat-pay.png')} />
        {i18n.t('pay.wechatPay')}
      </div>
    </li>
  )
}

export default MenuItem
